module.exports = __webpack_public_path__ + "static/media/poppy.685d004c.jpg";